<!--可查看svg图形树-->
<template>
  <div class="el_Tree_Body" :style="bodyStyle">
    <div class="elTree_hideButton">
      <div class="elTree_hideButton1" v-show="isShow" @click="isShow=!isShow">
        <el-button size="mini" icon="iconfont iconleft_shousuo"></el-button>
      </div>
      <div class="elTree_hideButton2" v-show="!isShow" @click="isShow=!isShow">
        <el-button size="mini" icon="iconfont iconrigth_shousuo"></el-button>
      </div>
    </div>
    <transition name="el-zoom-in-center">
      <div v-show="isShow" class="elTree_body">
        <div style="display: flex;padding-top:10px;align-items: center;">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style='width: 180px;margin-left: 15px;'>
          </el-input>
        </div>
        <el-scrollbar style="height:95%;width: 100%;">
          <el-tree accordion :expand-on-click-node="false" default-expand-all :data="dataList" node-key="id"
            :current-node-key='defaultSvg.id' :props="defaultProps" :filter-node-method="filterNode" ref="tree"
            @node-click="nodeClick">
            <span class="custom-tree-node" slot-scope="{node, data}">
              <img src="../../../../public/static/image/elTree/1.9.png" v-show="node.data.entityName=='UsePowerUnit'" />
              <img src="../../../../public/static/image/elTree/2.4.png" v-show="node.data.entityName=='Page'" />
              <span style="padding-left: 5px;">{{node.label }}</span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
    </transition>
  </div>
</template>

<script>
  import tree from './tree.vue'
  import resourcesStore from '@/cache/resourcesStore.js'
  export default {
    components: {
      tree
    },
    props: [],
    data () {
      return {
        filterText: '',
        nowCheckId: '',
        nowCheckItem: {},
        nowOpenFloorIds: [],
        playStatus: false,
        seconds: 20,
        nowIndex: -1,
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        defaultSvg: '',
        svgDataList: [],
        isShow: true,
      }
    },
    created () {},
    mounted () {
      this.diguiFilter(this.nowUnit.id,[this.getSvgTree])
      //加载以后默认选中第一个设备
      this.checkFirst(this.dataList)
      this.digui(this.dataList)
    },
    destroyed () {
      this.stopChange()
    },
    computed: {
      bodyStyle () {
        let width='0px'
        if(this.isShow) {
          width='2.5rem'
        }
        return {
          "width": width
        }
      },
      dataList () {
        var data=[
          {
            "leader": "",
            "unitNo": 31,
            "memo": "",
            "phoneNum": "",
            "type": 0,
            "capacity": 0,
            "entityName": "UsePowerUnit",
            "unitCode": "",
            "id": "1C00C7EDE52443B4A6F104C3C64BC219",
            "roomCount": 1,
            "inletWire": "",
            "address": "",
            "joinTime": 1668395530000,
            "fullName": "",
            "sort": 1,
            "parentId": "B5A693FA77804BC8BE009D57D0E7A788",
            "transformerCount": 0,
            "unitArea": null,
            "createTime": 1698974673000,
            "expirationTime": 1668395530000,
            "energIndex": null,
            "label": getName(),
            "loadCapacity": 0,
            "location": "114.06369,22.547923",
            "unitPeopleNumber": null,
            "energySavingRatio": null,
            "watchCount": null,
            "children": [
              {
                "children": [
                  {
                    "children": [

                      {
                        "pagetype": "wdr",
                        "id": "高压配电系统图.wdr",
                        "fileName": "高压配电系统图.wdr.115.svg",
                        "pagesort": 13,
                        "entityName": "Page",
                        "label": "高压配电系统图",
                        "attribute": 0,
                        "parentid": "",
                        "versionNumber": 124,
                        "pagelabel": "高压配电系统图.wdr"
                      },
                      {
                        "pagetype": "wdr",
                        "id": "搅拌系统.wdr",
                        "fileName": "搅拌系统.wdr.45.svg",
                        "pagesort": 14,
                        "entityName": "Page",
                        "label": "搅拌系统",
                        "attribute": 0,
                        "parentid": "",
                        "versionNumber": 45,
                        "pagelabel": "搅拌系统.wdr"
                      },
                      {
                        "pagetype": "wdr",
                        "id": "样柜.wdr",
                        "fileName": "样柜.wdr.23.svg",
                        "pagesort": 16,
                        "entityName": "Page",
                        "label": "样柜",
                        "attribute": 0,
                        "parentid": "",
                        "versionNumber": 2,
                        "pagelabel": "样柜.wdr"
                      }
                    ],
                    "leader": "",
                    "unitNo": 20,
                    "memo": "",
                    "phoneNum": "15976998552,13302535656",
                    "type": 0,
                    "capacity": 0,
                    "entityName": "UsePowerUnit",
                    "unitCode": "",
                    "id": "0A200022945047D7A5E538EDFC40FA21A",
                    "roomCount": 0,
                    "inletWire": "",
                    "address": "珠海市",
                    "joinTime": 1668395545000,
                    "fullName": "",
                    "sort": 2,
                    "parentId": "1C00C7EDE52443B4A6F104C3C64BC219",
                    "transformerCount": 0,
                    "unitArea": null,
                    "createTime": 1692059896000,
                    "expirationTime": 1668395545000,
                    "energIndex": null,
                    "label": "测试3",
                    "loadCapacity": 0,
                    "location": "113.613388,34.387973",
                    "unitPeopleNumber": null,
                    "energySavingRatio": null,
                    "watchCount": null
                  },
                  {
                    "children": [],
                    "leader": "zhang",
                    "unitNo": 17,
                    "memo": "测试",
                    "phoneNum": "15632526215",
                    "type": 0,
                    "capacity": 7,
                    "entityName": "UsePowerUnit",
                    "unitCode": "003",
                    "id": "8643062D4DAF4FA0B1A4EA0A71713ED4",
                    "roomCount": 4,
                    "inletWire": "9",
                    "address": "10",
                    "joinTime": 1668395565000,
                    "fullName": "测试",
                    "sort": 3,
                    "parentId": "1C00C7EDE52443B4A6F104C3C64BC219",
                    "transformerCount": 6,
                    "unitArea": null,
                    "createTime": 1687250797000,
                    "expirationTime": 1712212490000,
                    "energIndex": null,
                    "label": "测试",
                    "loadCapacity": 8,
                    "location": "102.831971,24.890173",
                    "unitPeopleNumber": null,
                    "energySavingRatio": null,
                    "watchCount": null
                  },
                  {
                    "children": [],
                    "leader": "",
                    "unitNo": 4,
                    "memo": "",
                    "phoneNum": "15812771076,13612211384",
                    "type": 0,
                    "capacity": 0,
                    "entityName": "UsePowerUnit",
                    "unitCode": "",
                    "id": "0281d0cc7fca4df8849e42687f55c617",
                    "roomCount": 0,
                    "inletWire": "",
                    "address": "",
                    "joinTime": 1671176354000,
                    "fullName": "",
                    "sort": 4,
                    "parentId": "1C00C7EDE52443B4A6F104C3C64BC219",
                    "transformerCount": 0,
                    "unitArea": null,
                    "createTime": 1671176351000,
                    "expirationTime": 1671176354000,
                    "energIndex": null,
                    "label": "设备公司",
                    "loadCapacity": 0,
                    "location": "",
                    "unitPeopleNumber": null,
                    "energySavingRatio": null,
                    "watchCount": 0
                  },
                  {
                    "children": [],
                    "leader": "",
                    "unitNo": 5,
                    "memo": "",
                    "phoneNum": "",
                    "type": 0,
                    "capacity": 0,
                    "entityName": "UsePowerUnit",
                    "unitCode": "",
                    "id": "9e0b4ec8962e4ab995f87b8294c5bcc0",
                    "roomCount": 0,
                    "inletWire": "",
                    "address": "",
                    "joinTime": 1672899961000,
                    "fullName": "",
                    "sort": 5,
                    "parentId": "1C00C7EDE52443B4A6F104C3C64BC219",
                    "transformerCount": 0,
                    "unitArea": null,
                    "createTime": 1672899962000,
                    "expirationTime": 1672899961000,
                    "energIndex": null,
                    "label": "测试2",
                    "loadCapacity": 0,
                    "location": "",
                    "unitPeopleNumber": null,
                    "energySavingRatio": null,
                    "watchCount": 0
                  },
                  {
                    "children": [],
                    "leader": "",
                    "unitNo": 12,
                    "memo": "",
                    "phoneNum": "",
                    "type": 1,
                    "capacity": null,
                    "entityName": "UsePowerUnit",
                    "unitCode": "",
                    "id": "7fbf4d3b83174aa9b74a27ef582e1b9a",
                    "roomCount": null,
                    "inletWire": "",
                    "address": "",
                    "joinTime": 1678779092000,
                    "fullName": "",
                    "sort": 6,
                    "parentId": "1C00C7EDE52443B4A6F104C3C64BC219",
                    "transformerCount": null,
                    "unitArea": null,
                    "createTime": 1681453991000,
                    "expirationTime": 1678779092000,
                    "energIndex": null,
                    "label": "测试3",
                    "loadCapacity": null,
                    "location": "",
                    "unitPeopleNumber": null,
                    "energySavingRatio": null,
                    "watchCount": null
                  },


                  {
                    "pagetype": "wdr",
                    "id": "搅拌系统.wdr",
                    "fileName": "搅拌系统.wdr.45.svg",
                    "pagesort": 4,
                    "entityName": "Page",
                    "label": "搅拌系统",
                    "attribute": 0,
                    "parentid": "",
                    "versionNumber": 33,
                    "pagelabel": "搅拌系统.wdr"
                  },
                  {
                    "pagetype": "wdr",
                    "id": "3号箱变.wdr",
                    "fileName": "3号箱变.wdr.57.svg",
                    "pagesort": 17,
                    "entityName": "Page",
                    "label": "3号箱变",
                    "attribute": 0,
                    "parentid": "",
                    "versionNumber": 3,
                    "pagelabel": "3号箱变.wdr"
                  }
                ],
                "leader": "",
                "unitNo": 31,
                "memo": "",
                "phoneNum": "",
                "type": 0,
                "capacity": 0,
                "entityName": "UsePowerUnit",
                "unitCode": "",
                "id": "1C00C7EDE52443B4A6F104C3C64BC219",
                "roomCount": 1,
                "inletWire": "",
                "address": "",
                "joinTime": 1668395530000,
                "fullName": "",
                "sort": 1,
                "parentId": "B5A693FA77804BC8BE009D57D0E7A788",
                "transformerCount": 0,
                "unitArea": null,
                "createTime": 1698974673000,
                "expirationTime": 1668395530000,
                "energIndex": null,
                "label": "设备-1#站点",
                "loadCapacity": 0,
                "location": "114.06369,22.547923",
                "unitPeopleNumber": null,
                "energySavingRatio": null,
                "watchCount": null
              }]
          }]

        var d=getMenuListAll()
        if(true) {
          data=[
            {
              "leader": "",
              "unitNo": 31,
              "memo": "",
              "phoneNum": "",
              "type": 0,
              "capacity": 0,
              "entityName": "UsePowerUnit",
              "unitCode": "",
              "id": "1C00C7EDE52443B4A6F104C3C64BC219",
              "roomCount": 1,
              "inletWire": "",
              "address": "",
              "joinTime": 1668395530000,
              "fullName": "",
              "sort": 1,
              "parentId": "B5A693FA77804BC8BE009D57D0E7A788",
              "transformerCount": 0,
              "unitArea": null,
              "createTime": 1698974673000,
              "expirationTime": 1668395530000,
              "energIndex": null,
              "label": getName()+"有限公司",
              "loadCapacity": 0,
              "location": "114.06369,22.547923",
              "unitPeopleNumber": null,
              "energySavingRatio": null,
              "watchCount": null,
              "children": [
                {
                  "children": [
                    {
                      "children": [
                        {
                          "pagetype": "wdr",
                          "id": "333",
                          "fileName": "c栋b区一层配电站3.svg",
                          "pagesort": 10,
                          "entityName": "Page",
                          "label": "c栋b区一层配电站3",
                          "attribute": 0,
                          "parentid": "",
                          "versionNumber": 101,
                          "pagelabel": "智意机器人.wdr"
                        }
                      ],
                      "leader": "",
                      "unitNo": 20,
                      "memo": "",
                      "phoneNum": "15976998552,13302535656",
                      "type": 0,
                      "capacity": 0,
                      "entityName": "UsePowerUnit",
                      "unitCode": "",
                      "id": "0A200022945047D7A5E538EDFC40FA2A2",
                      "roomCount": 0,
                      "inletWire": "",
                      "address": "珠海市",
                      "joinTime": 1668395545000,
                      "fullName": "",
                      "sort": 2,
                      "parentId": "1C00C7EDE52443B4A6F104C3C64BC219",
                      "transformerCount": 0,
                      "unitArea": null,
                      "createTime": 1692059896000,
                      "expirationTime": 1668395545000,
                      "energIndex": null,
                      "label": "高压保护",
                      "loadCapacity": 0,
                      "location": "113.613388,34.387973",
                      "unitPeopleNumber": null,
                      "energySavingRatio": null,
                      "watchCount": null
                    },
                    {
                      "children": [
                        {
                          "pagetype": "wdr",
                          "id": "111",
                          "fileName": "c栋b区一层配电站.svg",
                          "pagesort": 10,
                          "entityName": "Page",
                          "label": "c栋b区一层配电站",
                          "attribute": 0,
                          "parentid": "",
                          "versionNumber": 101,
                          "pagelabel": "智意机器人.wdr"
                        },
                        {
                          "pagetype": "wdr",
                          "id": "222",
                          "fileName": "c栋b区一层配电站2.svg",
                          "pagesort": 10,
                          "entityName": "Page",
                          "label": "c栋b区一层配电站2",
                          "attribute": 0,
                          "parentid": "",
                          "versionNumber": 101,
                          "pagelabel": "智意机器人.wdr"
                        },
                        {
                          "pagetype": "wdr",
                          "id": "工况图2.wdr",
                          "fileName": "工况图2.wdr.svg",
                          "pagesort": 10,
                          "entityName": "Page",
                          "label": "工况图",
                          "attribute": 0,
                          "parentid": "",
                          "versionNumber": 101,
                          "pagelabel": "工况图2.wdr"
                        }
                      ],
                      "leader": "",
                      "unitNo": 20,
                      "memo": "",
                      "phoneNum": "15976998552,13302535656",
                      "type": 0,
                      "capacity": 0,
                      "entityName": "UsePowerUnit",
                      "unitCode": "",
                      "id": "0A200022945047D7A5E538EDFC40FA2A3",
                      "roomCount": 0,
                      "inletWire": "",
                      "address": "珠海市",
                      "joinTime": 1668395545000,
                      "fullName": "",
                      "sort": 2,
                      "parentId": "1C00C7EDE52443B4A6F104C3C64BC219",
                      "transformerCount": 0,
                      "unitArea": null,
                      "createTime": 1692059896000,
                      "expirationTime": 1668395545000,
                      "energIndex": null,
                      "label": "低压仪表",
                      "loadCapacity": 0,
                      "location": "113.613388,34.387973",
                      "unitPeopleNumber": null,
                      "energySavingRatio": null,
                      "watchCount": null
                    },


                  ],
                  "leader": "",
                  "unitNo": 31,
                  "memo": "",
                  "phoneNum": "",
                  "type": 0,
                  "capacity": 0,
                  "entityName": "UsePowerUnit",
                  "unitCode": "",
                  "id": "1C00C7EDE52443B4A6F104C3C64BC219",
                  "roomCount": 1,
                  "inletWire": "",
                  "address": "",
                  "joinTime": 1668395530000,
                  "fullName": "",
                  "sort": 1,
                  "parentId": "B5A693FA77804BC8BE009D57D0E7A788",
                  "transformerCount": 0,
                  "unitArea": null,
                  "createTime": 1698974673000,
                  "expirationTime": 1668395530000,
                  "energIndex": null,
                  "label": "C栋B区一层配电房",
                  "loadCapacity": 0,
                  "location": "114.06369,22.547923",
                  "unitPeopleNumber": null,
                  "energySavingRatio": null,
                  "watchCount": null
                }]
            }]

        }

        return data
      },
      svgList () {
        if(this.dataList[0]==undefined) {
          return []
        }
        return treeToList(this.dataList[0],'next',item => item.hasOwnProperty('next')).filter(item => item.entityName==
          'Page')
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      getSvgTree () {
        return this.$store.svgStore.getters.getSvgTree
      }
    },
    watch: {
      getSvgTree (nv,ov) {
        this.diguiFilter(this.nowUnit.id,[this.getSvgTree])
      },
      dataList (nv,ov) {
        /*if(isempty(ov[0])) {*/
        this.digui(nv)
        /*}*/
      },
      nowCheckItem (nv,ov) { 
        this.$emit("checkItem",nv)
        this.nowIndex=this.svgList.findIndex(item => nv.path==item.path)
      },
      seconds (nv,ov) {
        this.stopChange()
        if(isempty(nv)||parseInt(nv)!=this.seconds) {
          if(isempty(ov)) {
            this.seconds=parseInt(nv)
          } else {
            this.seconds=ov
          }
        }
        if(nv<10) {
          this.seconds=10
          this.$dialogMethod.showMessage("最小间隔为10秒!")
        }

      },
      defaultSvg (nv,ov) {
        var d = this.$store.menuStore.state.nowMenu.pageFile;
        if (d) {
          nv.fileName =d;
        }
        this.$emit('checkItem',nv)
      },
      nowUnit (nv,ov) {
        this.diguiFilter(nv.id,[this.getSvgTree])
      }
    },
    methods: {
      filterNode (value,data) {
        if(!value) return true;
        return data.label.indexOf(value)!==-1;
      },
      nodeClick (value,nodeData) {
        value.name=value.label
        if(value.entityName=="Page") { 
          this.$emit('checkItem',value)
        }
      },
      checkFirst (dataList) {
        if(isempty(dataList)) {
          return
        }
        //递归打开层级直到找到第一个设备
        var obj=this.findDevice(this.dataList)
        if(obj==undefined) {
          return
        }
        this.nowOpenFloorIds=obj.floor
        this.nowCheckId=this.getIdMethod(obj.device)
        this.nowCheckItem=obj.device
      },
      imgMethod (item) {
        switch(item.entityName) {
          case "UsePowerUnit":
            return resourcesStore.getters.getResourcesByName("tree/node_unit.png")
          case "Page":
            return resourcesStore.getters.getResourcesByName("tree/node_dev.png")
          default:
            return 'resourcesStore.getters.getResourcesByName("tree/node_class.png")'
        }
      },
      getIdMethod (item) {
        switch(item.entityName) {
          case "Page":
            return item.path
          default:
            return item.id
        }
      },
      checkItem (item) {
        this.nowCheckId=this.getIdMethod(item)
        this.nowCheckItem=item
      },
      // 开始自动切换
      startChange () {
        this.stopChange()
        // 添加定时任务
        this.playStatus=true
        addNewTask('changeSvgTimer',this.seconds*1000,this.seconds*1000,-1,() => {
          if(this.nowIndex==this.svgList.length-1) {
            this.checkItem(this.svgList[0])
          } else {
            this.checkItem(this.svgList[this.nowIndex+1])
          }
        })
      },
      findDevice (dataList) {
        var list=[]
        for(var i=0,len=dataList.length;i<len;i++) {
          var item=dataList[i]
          if(item.entityName=='Page') {
            //是设备,返回吧
            return {
              device: item,
              floor: []
            }
          } else if(!isempty(item.next)) {
            //找一下下级
            var obj=this.findDevice(item.next)
            if(obj!=undefined) {
              //找到了,把自己的id也加进去
              obj.floor.push(this.getIdMethod(item))
              return obj
            }
          }
        }
      },
      stopChange () {
        this.playStatus=false
        removeTask('changeSvgTimer')
      },
      listenKeydown (ev) {
        if(ev.keyCode==109||ev.keyCode==110||ev.keyCode==190||ev.keyCode==229) {
          ev.preventDefault()
        }
      },
      digui (list) {
        list.forEach(item => {
          if(!isempty(item.children)) {
            this.digui(item.children)
          } else {
            if(item.entityName=="Page") {
              /*if(isempty(this.defaultSvg)) {*/
              this.defaultSvg=item
              /*}*/
            }
          }
        })
      },
      diguiFilter (id,list) {
        list.forEach(item => {
          if(item.id==id) {
            this.svgDataList=item
          } else {
            if(!isempty(item.next)) {
              this.diguiFilter(id,item.next)
            }
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .custom-tree-node {
    display: flex;
    align-items: center;
  }

  /deep/.el-tree-node__content:hover {
    background-color: #eaf4ff !important;
  }

  /deep/ .is-current>.el-tree-node__content {
    background-color: #add5ff !important;
  }
</style>